export default __webpack_public_path__ + "static/media/agustin13.4525ae79.png";